import type { GpgsPort, GpgsSignInResult } from "./gpgsPorts.js";

/** No-op GPGS implementation for web, unsupported platforms, tests, and fallback paths. */
export class NoopGpgsAdapter implements GpgsPort {
  isAvailable(): boolean {
    return false;
  }

  async signIn(): Promise<GpgsSignInResult> {
    return { authenticated: false };
  }

  async unlockAchievement(_achievementId: string): Promise<void> {
    /* no-op */
  }

  async incrementAchievement(_achievementId: string, _steps: number): Promise<void> {
    /* no-op */
  }

  async submitLeaderboardScore(_leaderboardId: string, _score: number): Promise<void> {
    /* no-op */
  }

  async getServerAuthCode(): Promise<string | null> {
    return null;
  }
}
